import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  ListGroup,
  Button,
  Modal,
  InputGroup,
  FormControl,
  Form,
} from "react-bootstrap";
import { useDispatch } from "react-redux";
import SpinnerButton from "../SpinnerButton/SpinnerButton";
import { showModal, showSpinner } from "../../Slices/sessionSlice";
import { saveTask } from "./../../Slices/candidateSlice";
import styles from "./CreateTask.module.css";
export const id = "CREATE_TASK";
const saveTaskId = "createTask.save";

const CreateTask = (data) => {
  const dispatch = useDispatch();
  const [taskName, setTaskName] = React.useState("");
  const [selectedProject, setSelectedProject] = React.useState(
    data.data.at(0).projectId
  );

  const saveTaskHandler = () => {
    dispatch(showSpinner({ id: saveTaskId }));
    const payload = { projectId: selectedProject, taskName };
    dispatch(saveTask(payload));
  };

  return (
    <>
      <Modal
        show={true}
        centered
        onHide={() => {
          dispatch(showModal(null));
        }}
      >
        <Modal.Header className="justify-content-center" closeButton>
          <h3>Create Task</h3>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <InputGroup className="mb-3">
              <InputGroup.Text id="basic-addon1">Project</InputGroup.Text>
              <Form.Select
                aria-label="Default select example"
                value={selectedProject}
                onChange={(e) => {
                  setSelectedProject(e.target.value);
                }}
              >
                {data.data.map((item) => (
                  <option
                    key={`option - ${item.projectId}`}
                    value={item.projectId}
                  >
                    {item.name}
                  </option>
                ))}
              </Form.Select>
            </InputGroup>
            <InputGroup className="mb-3">
              <InputGroup.Text
                className={`${styles.task_name}`}
                id="inputGroup-sizing-default"
              >
                Task
              </InputGroup.Text>
              <Form.Control
                aria-label="Default"
                aria-describedby="inputGroup-sizing-default"
                placeholder="enter a New Task Name"
                value={taskName}
                onChange={(e) => {
                  setTaskName(e.target.value);
                }}
              />
            </InputGroup>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <SpinnerButton
            disabled={taskName === ""}
            variant="outline-primary"
            id={saveTaskId}
            onClick={saveTaskHandler}
            name="Save"
          />
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CreateTask;
